// SPDX-License-Identifier: Apache-2.0
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.depositors = void 0;
const contracts_deposit_1 = require("./contracts_deposit");
exports.depositors = new Map([
    ["ETH", contracts_deposit_1.makeETHDepositCalls],
    ["ERC20", contracts_deposit_1.makeERC20DepositCalls],
    ["ERC721", contracts_deposit_1.makeERC721DepositCalls],
    ["ERC721Mintable", contracts_deposit_1.makeERC721DepositCalls],
]);
//# sourceMappingURL=tokenmanager.js.map